import JournalTextArticlePage from './JournalTextArticlePage'

/**
 * Piece: The Cost of Sustainability in the World of Fast Fashion.
 * Full text (same essay as the PDF) — Helvetica body / Caveat title via shell.
 */
export default function CostOfSustainabilityFashion() {
  return (
    <JournalTextArticlePage title="The Cost of Sustainability in the World of Fast Fashion" titleFont='"Helvetica Neue", Helvetica, Arial, sans-serif'>
      <p className="journalTextArticleMeta">By: Kalkidane Negewo</p>
      <p className="journalTextArticleMeta">October 2024</p>
      <p>
        From instant food, to Instacart, to next day delivery courtesy of your favorite
        billionaire. The simplicity of the convenience has swallowed itself whole into something
        that, behaviorally, might be difficult to turn back from. One of the highest rises in the
        world of neoliberal consumerism is fast fashion. The aggrandization this sub-industry has
        throughout a global consumer&apos;s point of view is a bit shocking to say the least.
        Fashion Nova, Zara, Shein, &amp; recently Temu, are a few of the fast fashion juggernauts
        that have swept the globe in convincing men &amp; women everywhere why they need this
        poorly made cheap item of clothing at $20. Merriam-Webster defines fast fashion as
        &ldquo;an approach to the design, creation, and marketing of clothing fashions that
        emphasizes making fashion trends quickly and cheaply available to consumers&rdquo;. This
        quick availability to consumers is unfortunately linked to the quick impact on the
        geoeconomics as well. There are many challenges that come with the negligent consumerism
        from fast fashion.
      </p>
      <p>
        The impact of excessive clothing waste is the most obvious issue this phenomenon creates.
        Due to the cheap cost of materials, labor &amp; manufacturing; oftentimes these fast
        fashion brands conduct their work in sweat shops that create extremely hazardous
        situations for the workers &amp; the environments that they are found in within a
        developing country. The excess of clothing of poor quality is causing real estate in land
        dumps that creates heavier hazards. The trendiness &amp; convenience allows the consumer to
        feel fashionable without the commitment to a price tag from a luxury designer. However,
        they also neglect to take into consideration the quality &amp; craftsmanship behind that
        higher price tag.
      </p>
      <p>
        If someone buys a pair of boots from Shein, &amp; another pair from Prada; the long-term
        potential will be clear. The Prada boot provides a quality you can trust, a manufacturing
        that will last years (if handled well), &amp; the craft time that will be worth the money
        you spend. Why? Because it is designed with concern for the consumer. Whereas our fast
        fashion counterparts are not interested in that time consuming cycle. The profit &amp;
        allowing their consumers to remain ignorant in convenience is suffice. Besides contributing
        to the increased &ldquo;first world problems&rdquo;, there is the underlying environmental
        impact. Based on a scholarly article by Emma Williams for the{' '}
        <em>Journal for Global Business &amp; Community</em>, &ldquo;over time, chemicals, and dyes
        from the fabric of these clothing pieces begin to seep into the ground. This leaching can
        cause toxic materials to &lsquo;be taken up by plants and animals, contaminate a human
        drinking water supply or volatilize and contaminate the indoor air in overlying
        buildings&rsquo;&rdquo; (Williams 2022). Many of these sweatshops are also contributing to
        excessive water usage that adds to the flowing of pollution, clothing microfibers, plastics
        &amp; other toxins into the ocean. With billions of people unable to access clean drinking
        water, the immoral manufacturing of these clothes hits an ethical code for many. However,
        it&apos;s not limited to the poor working habits for individuals, or water quality. Research
        shows elevated carbon &amp; greenhouse emissions that fits as a cherry on top to this
        fashion fiasco.
      </p>
      <p>
        The fashion industry is guilty of producing intense greenhouse emissions. However,
        polyester, a textile prominently used in fast fashion, &ldquo;produced about 1.5 trillion
        pounds (706 billion kilograms) of greenhouse gases on its own in 2015. While the fashion
        industry&apos;s greenhouse emissions are already high, according to Elisa Tonda, Head of
        Consumption and Production Unit at the United Nations Environment Programme, if we carry on
        with a business-as-usual approach, the greenhouse gas emissions from the industry are
        expected to rise by almost 50% by 2030&rdquo; (Williams 2022).
      </p>
      <p>
        Of course there are many simple solutions consumers can do today. Donate clothing that has
        lost its trend. Many donation centers can be found across America, and some places will
        provide compensation for your items. Another obvious option is not becoming bait to the mass
        retail chain. Not every item that is seen as &ldquo;trendy&rdquo; needs to be bought. It
        will not only save consumers a surprising amount but can create desire for the individual
        to enjoy the retail experience again by waiting for an anticipated product. Let it be
        noted that the luxury fashion industry is not exempt from the environmental limitations
        they are imposing globally. However, the accelerated speed at which fast fashion companies
        are producing is not sustainable for their consumers nor for the environment. It will be a
        challenge to convince the liberated mind to believe they can make an impact from not
        shopping till they drop, but the constraints can truly produce promising environmental
        effects long term.
      </p>
    </JournalTextArticlePage>
  )
}
